// Validators for Teacher Application Form
import {
  SubjectsAndSchools,
  TeacherApplicationForm,
  DAYS_OF_WEEK,
  TIME_SLOTS,
  getAvailabilityFieldName,
} from '../model/TeacherApplicationForm';

// Re-export existing validators from validators.ts
export { validateEmail, validateName, validateItalianPhone } from './validators';

/**
 * Validate province field
 */
export const validateProvince = (province_id: number): string => {
  if (!province_id || province_id === 0) {
    return 'La provincia è obbligatoria';
  }
  return '';
};

/**
 * Validate city field
 */
export const validateCity = (city_id: number): string => {
  if (!city_id || city_id === 0) {
    return 'La città è obbligatoria';
  }
  return '';
};

/**
 * Validate street field
 */
export const validateStreet = (street_name: string): string => {
  if (!street_name || street_name.trim().length === 0) {
    return 'L\'indirizzo è obbligatorio';
  }
  return '';
};

/**
 * Validate zip code field
 */
export const validateZip = (zip: string): string => {
  if (!zip || zip.trim().length === 0) {
    return 'Il CAP è obbligatorio';
  }
  if (!/^\d{5}$/.test(zip)) {
    return 'Il CAP deve essere di 5 cifre';
  }
  return '';
};

/**
 * Validate qualifications field
 */
export const validateQualifications = (qualifications: string): string => {
  if (!qualifications || qualifications.trim().length === 0) {
    return 'Le qualifiche sono obbligatorie';
  }
  return '';
};

/**
 * Validate current employment field
 */
export const validateEmployment = (employment: string): string => {
  if (!employment || employment.trim().length === 0) {
    return 'L\'occupazione attuale è obbligatoria';
  }
  return '';
};

/**
 * Validate subjects selection
 */
export const validateSubjects = (subjects: SubjectsAndSchools[]): string => {
  if (!subjects || subjects.length === 0) {
    return 'Seleziona almeno una materia';
  }

  // Check each subject
  for (const subject of subjects) {
    if (!subject.id) {
      return 'ID materia mancante';
    }

    if (!subject.schools || subject.schools.length === 0) {
      return 'Seleziona almeno una scuola per ogni materia';
    }

    for (const school of subject.schools) {
      if (!school.id) {
        return 'ID scuola mancante';
      }

      if (!school.classes || school.classes.length === 0) {
        return 'Seleziona almeno una classe per ogni scuola';
      }
    }
  }

  return '';
};

/**
 * Validate weekly availability
 * Returns error if no time slots are selected
 */
export const validateAvailability = (formData: TeacherApplicationForm): string => {
  let hasAtLeastOne = false;

  // Check all 56 availability fields
  for (const day of DAYS_OF_WEEK) {
    for (const timeSlot of TIME_SLOTS) {
      const fieldName = getAvailabilityFieldName(day, timeSlot);
      if (formData[fieldName] === true) {
        hasAtLeastOne = true;
        break;
      }
    }
    if (hasAtLeastOne) break;
  }

  if (!hasAtLeastOne) {
    return 'Seleziona almeno una fascia oraria di disponibilità';
  }

  return '';
};

/**
 * Validate has_car field (must be explicitly set)
 */
export const validateHasCar = (hasCar: boolean | null | undefined): string => {
  if (hasCar === null || hasCar === undefined) {
    return 'Indica se possiedi un\'auto';
  }
  return '';
};

/**
 * Count selected availability slots
 */
export const countSelectedAvailability = (formData: TeacherApplicationForm): number => {
  let count = 0;

  for (const day of DAYS_OF_WEEK) {
    for (const timeSlot of TIME_SLOTS) {
      const fieldName = getAvailabilityFieldName(day, timeSlot);
      if (formData[fieldName] === true) {
        count++;
      }
    }
  }

  return count;
};
